import { useState } from 'react';

import { EventVideoInfoType } from '../../feature/type/EventVideoInfoType';

/**
 * イベント映像一覧の状態管理用カスタムフック
 */
export const useStateEventVideo = () => {
	const [eventVideoInfoList, setEventVideoInfoList] = useState<EventVideoInfoType[]>([]); // 取得したイベント映像一覧の管理

	return {
		eventVideoInfoList,
		setEventVideoInfoList,
	};
};
